import axios from 'axios';

const http = axios;

export default (Vue, { store, router }) => {
  http.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.getters.access_token;
    config.headers["X-Rozetta-Client"] = "Web UI/" + store.getters.client_version;
    if(store.getters.debug_source_ip){
      try{
        var source_ip = localStorage.getItem('source_ip');
        if(source_ip !== null){
          config.headers["X-Source-Ip"] = source_ip;
        }
      }catch(e){
      }
    }
    return config;
  });

  http.interceptors.response.use((response) => {
    store.commit("setHttpLog", {
      type: "response",
      response: response,
      date: Math.floor(new Date() / 1000)
    });
    return response;
  }, (error) => {
    store.commit("setHttpLog",{
      type: "error",
      response: error.response,
      date: Math.floor(new Date() / 1000)
    });
    throw error;
  });

  Vue.http = http;
  Object.defineProperties(Vue.prototype, {
    $http: {
      get () {
        return http;
      }
    }
  });
};
